import { createContext, useContext } from "react";
import { formatCents, Moeda, simboloMoeda } from "@/utils/money";

const MoedaDaPropostaContext = createContext<Moeda>(Moeda.BRL);

export const MoedaDaPropostaProvider = MoedaDaPropostaContext.Provider;

/** Os valores da proposta (documento, períodos, totais) ficam na moeda dela. Só as OS saem em reais. */
export function useMoedaDaProposta() {
  const moeda = useContext(MoedaDaPropostaContext);
  return { moeda, simbolo: simboloMoeda(moeda), formatar: (cents: number | null | undefined) => formatCents(cents, moeda) };
}
